<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <div class="box-title-container mb-1 ion-padding-horizontal">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div class="icon-container">
            <ion-icon name="bed"></ion-icon>
          </div>
          <div>
            <p class="title">Hotels Accommodation</p>
          </div>
        </div>

        <div class="input-container d-flex align-items-center gap-1" *ngIf="!serviceBasedSections.showTourPackage && !serviceBasedSections.showRouteCraft">
          <div class="">
            <label class="label">Currency</label>
          </div>
          <select class="input py-1 border-1" (change)="onCurrencyChange($event)">
            <option *ngFor="let item of currencyLov" [selected]="selectedCurrency === item.key" [value]="item.key">{{item.name}}</option>
          </select>
        </div>
      </div>
    </div>

    <form [formGroup]="accommodationForm">
      <div class="form-container">
        <div formArrayName="data" class="ion-padding-horizontal">
          <div class="single-destination-container" *ngFor="let destination of destinationFormArray().controls; let destIndex = index" [formGroupName]="destIndex">      
            <div formArrayName="locations">
              <div class="single-accommodation-container" *ngFor="let accommodation of locationFormArray(destIndex).controls; let locationIndex = index" [formGroupName]="locationIndex">
                <div class="d-flex justify-content-between align-items-center destination-title-container">
                  <div class="d-flex">
                    <p class="destination-name"><b>Destination {{destIndex + 1}}</b> {{destination.get("destination")?.value}}</p>
                    <span *ngIf="destination.errors?.['totalHotelNightsMismatch']" class="error-message">
                      Total number of nights across all hotels must be {{ preferredDestinations[destIndex]?.days }}.
                    </span>
                    <span *ngIf="destination.errors?.['unequalHotelNightsInLocation']" class="error-message">
                      All hotels in each location must have the same number of nights.
                    </span>
                    <span *ngIf="!isCheckinDatesValid(destIndex, locationIndex)" class="error-message">
                      Check-in and Check-out dates are mandatory
                    </span>
                  </div>

                  <div class="d-flex align-items-center gap-1">
                    <div class="stars-container" *ngIf="hotelsFormArray(destIndex, locationIndex).length == 1">
                      <span class="star" *ngFor="let s of getNoOfStars(destIndex, locationIndex)">★</span>
                    </div>
                    <div class="d-flex align-items-center hotel-date-container">
                      <p class="label">Check-in</p>
                      <app-date-picker
                       [minDate]="convertToDate(tripStartDate)" [maxDate]="convertToDate(tripEndDate)"
                       [selectedDate]="getCheckInDate(destIndex, locationIndex)" (change)="setCheckInDate(destIndex, locationIndex, $event)"></app-date-picker>
                    </div>
                    <div class="d-flex align-items-center hotel-date-container">
                      <p class="label">Check-out</p>
                      <app-date-picker 
                      [minDate]="convertToDate(tripStartDate)" [maxDate]="convertToDate(tripEndDate)"
                      [selectedDate]="getCheckOutDate(destIndex, locationIndex)" (change)="setCheckOutDate(destIndex, locationIndex, $event)"></app-date-picker>
                    </div>
                  </div>
                </div> 

                <div class="row">
                  <div class="col-10" *ngIf="locationFormArray(destIndex).length !== 1">
                    <div class="input-container d-flex align-items-center">
                      <h2 class="location-title fs-6 me-3">Location</h2>
                      <div class="location-input-container"
                        [ngClass]="{ 'invalid-input': accommodation.get('locationName')?.invalid && accommodation.get('locationName')?.touched }">
                        <app-locations-autocomplete formControlName="locationName"></app-locations-autocomplete>
                      </div>
                      <span *ngIf="destination.errors?.['unequalHotelNightsInLocation']" class="error-message">
                        All hotels in each location must have the same number of nights.
                      </span>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="d-flex justify-content-end align-items-start">
                      <div class="w-100 d-flex justify-content-end">
                          <button type="button" class="add-more-btn" *ngIf="locationFormArray(destIndex).length !== 1" (click)="removeLocation(destIndex, locationIndex)">x Remove Location</button>
                        </div>
                    </div>
                  </div>
                </div>

                <ng-container formArrayName="hotels">            
                  <ng-container *ngFor="let hotel of hotelsFormArray(destIndex, locationIndex).controls; let hotelIndex = index" [formGroupName]="hotelIndex">
                    <div class="row">
                      <div class="col-12">
                        <div class="w-100 d-flex justify-content-end">
                          <button type="button" class="add-more-btn mb-0" (click)="removeHotel(destIndex ,locationIndex, hotelIndex)"
                            *ngIf="hotelsFormArray(destIndex, locationIndex).length !== 1">x Remove Hotel</button>
                        </div>
                      </div>
                    </div>

                    <div class="hotel-grid-main-container" [ngClass]="{'hotel-gray-bg': hotelIndex%2==1}">
                      <div class="hotel-details-container">
                        <div class="hotels-row-1">
                          <div class="">
                            <div class="input-container" style="width: 250px;">
                              <label for="hotelName" class="label">Hotel Name*</label>
                              <div [ngClass]="{ 'invalid-input': hotel.get('hotelName')?.invalid && hotel.get('hotelName')?.touched }"> 
                                <app-hotel-auto-complete [locationvalue]="accommodation.get('locationName')?.value"
                                formControlName="hotelName"
                                (predictionSelected)="gettingPopulatedHotelvalues($event, destIndex, locationIndex, hotelIndex)"></app-hotel-auto-complete>
                              </div>
                            </div>
                          </div>

                          <div class="">
                            <div class="input-container">
                              <label for="" class="label">Hotel Category*</label>
                              <div [ngClass]="{ 'invalid-input': hotel.get('hotelType')?.invalid && hotel.get('hotelType')?.touched }">
                                <app-stars-input
                                  formControlName="hotelType">
                                </app-stars-input>
                              </div>
                            </div>
                          </div>

                          <!-- <div class="">
                            <div class="input-container">
                              <div>
                                <label for="" class="label">Check-in Time</label>
                                <app-time-picker formControlName="checkInTime"></app-time-picker>
                              </div>
                            </div>
                          </div>

                          <div class="">
                            <div class="input-container">
                              <div>
                                <label for="" class="label">Check-out Time</label>
                                <app-time-picker formControlName="checkOutTime"></app-time-picker>
                              </div>
                            </div>
                          </div> -->

                          <div class="">
                            <div class="input-container">
                              <label for="" class="label">Nights*</label>
                              <div
                                [ngClass]="{ 'invalid-input': hotel.get('noOfNights')?.invalid && hotel.get('noOfNights')?.touched }">
                                <app-increment-number-input formControlName="noOfNights"></app-increment-number-input>
                              </div>
                            </div>
                          </div>

                          <div class="">
                            <div class="input-container">
                              <label for="" class="label">Rooms*</label>
                              <div
                                [ngClass]="{ 'invalid-input': hotel.get('noOfRooms')?.invalid && hotel.get('noOfRooms')?.touched }">
                                <app-increment-number-input formControlName="noOfRooms"></app-increment-number-input>
                              </div>
                            </div>
                          </div>                          
                        </div>

                        <ng-container formArrayName="rooms">
                          <ng-container *ngFor="let roomControl of getRoomsFormArray(destIndex, locationIndex, hotelIndex).controls; let roomIndex = index">
                            <div class="hotels-row-2" [formGroupName]="roomIndex">
                              <div class="">
                                <div class="input-container" style="width: 250px;">
                                  <label for="" class="label">Room <span>{{roomIndex + 1}}</span> Category</label>
                                  <div
                                    [ngClass]="{ 'invalid-input': roomControl.get('roomCategory')?.invalid && roomControl.get('roomCategory')?.touched }">
                                    <app-dropdown-select [dropdownValues]="roomCategory"
                                      formControlName="roomCategory"></app-dropdown-select>
                                  </div>
                                </div>
                              </div>

                              <div class="">
                                <div class="input-container occupancy">
                                  <label for="" class="label">Adult Occupancy</label>
                                  <div
                                    [ngClass]="{ 'invalid-input': roomControl.get('occupancyAdult')?.invalid && roomControl.get('occupancyAdult')?.touched }">
                                    <app-increment-number-input formControlName="occupancyAdult"></app-increment-number-input>
                                  </div>
                                </div>
                              </div>

                              <div class="">
                                <div class="input-container occupancy">
                                  <label for="" class="label">Children Occupancy</label>
                                  <div
                                    [ngClass]="{ 'invalid-input': roomControl.get('occupancyChild')?.invalid && roomControl.get('occupancyChild')?.touched }">
                                    <app-increment-number-input formControlName="occupancyChild"></app-increment-number-input>
                                  </div>
                                </div>
                              </div>

                              <div class="">
                                <div class="input-container">
                                  <label for="" class="label">Extra Beds</label>
                                  <div
                                    [ngClass]="{ 'invalid-input': roomControl.get('extraBeds')?.invalid && roomControl.get('extraBeds')?.touched }">
                                    <app-increment-number-input formControlName="extraBeds"></app-increment-number-input>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                      <div class="meals-container">
                        <div class="">
                        <div class="input-container">
                          <label for="" class="label">Meal Plan</label>
                          <div [ngClass]="{ 'invalid-input': hotel.get('mealPlan')?.invalid && hotel.get('mealPlan')?.touched }">
                            <app-meal-plan-input [flexColumn]="true" [items]="meals" [selectAllKey]="MEAL_PLAN.ALL_INCLUSION" formControlName="mealPlan"></app-meal-plan-input>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>

                    <div class="row" *ngIf="!serviceBasedSections.showTourPackage && !serviceBasedSections.showRouteCraft">
                      <div class="col-3">
                        <div class="input-container">
                          <label for="" class="label">Cost / Adult*</label>
                          <div
                            [ngClass]="{ 'invalid-input': hotel.get('costPerAdult')?.invalid && hotel.get('costPerAdult')?.touched }">
                            <app-cost-pricing-input formControlName="costPerAdult" [disableDrowdown]="true" [prefix]="selectedCurrency"
                              [dropdownArray]="noOfAdutlsDropdown"></app-cost-pricing-input>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="input-container">
                          <label for="" class="label">Cost / child with bed*</label>
                          <div
                            [ngClass]="{ 'invalid-input': hotel.get('costPerChild')?.invalid && hotel.get('costPerChild')?.touched }">
                            <app-cost-pricing-input formControlName="costPerChild" [prefix]="selectedCurrency"
                              [dropdownArray]="noOfChildrenDropdown"></app-cost-pricing-input>

                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="input-container">
                          <label for="" class="label">Cost / child without bed*</label>
                          <div
                            [ngClass]="{ 'invalid-input': hotel.get('costPerInfant')?.invalid && hotel.get('costPerInfant')?.touched }">
                            <app-cost-pricing-input formControlName="costPerInfant" [prefix]="selectedCurrency"
                              [dropdownArray]="noOfChildrenDropdown"></app-cost-pricing-input>
                          </div>
                        </div>
                      </div>

                      <div class="col-3">
                        <div class="input-container">
                          <label for="" class="label">Total Accommodation cost*</label>
                          <div
                            [ngClass]="{ 'invalid-input': hotel.get('totalAccommodationCost')?.invalid && hotel.get('totalAccommodationCost')?.touched }">
                            <app-select-text-input [prefix]="selectedCurrency" formControlName="totalAccommodationCost"
                              [readonly]="true"></app-select-text-input>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row justify-content-end">
                      <div class="col">
                        <div class="d-flex justify-content-end align-items-end h-100">
                          <!-- Add hotel for the same location -->
                          <button type="button" class="add-more-btn me-3 mb-1" (click)="addHotelAtLocation(destIndex ,locationIndex, hotelIndex)">+ Hotel</button>
                          <!-- Add hotel at new location -->
                          <button *ngIf="hotelIndex+1 === hotelsFormArray(destIndex, locationIndex).length" type="button" class="add-more-btn mb-1" (click)="addLocationAtDestination(destIndex)">+ Split Stay</button>
                        </div>
                      </div>
                    </div>

                    <div class="dashed-line my-1"></div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <!-- Hotel terms and conditons -->
        <div class="box-title-container mb-1 ion-padding-horizontal">
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <div class="icon-container">
                <ion-icon name="bed"></ion-icon>
              </div>
              <div>
                <p class="title">Hotels Terms & Conditions</p>
              </div>
            </div>
          </div>
        </div>
        <div class="ion-padding-horizontal">
          <div class="row">
            <div class="col">
              <div class="input-container">
                <app-selectable-list-items 
                  [addButtonText]="'Add Hotel Terms & Conditions'"
                  formControlName="hotelTermsAndConditions"
                  (setDefaultEmitter)="setDefaultLov($event, 'HotelTermsAndConditions', 'hotelTermsAndConditions')"
                  (removeDefaultEmitter)="removeDefaultLov($event, 'HotelTermsAndConditions', 'hotelTermsAndConditions')"
                ></app-selectable-list-items>
              </div>
            </div>
          </div>
        </div>


        <div class="ion-padding-horizontal">
          <div class="row">
            <div class="col">
              <div class="input-container">
                <label for="" class="label">Notes</label>
                <div
                  [ngClass]="{ 'invalid-input': accommodationForm.get('sectionNote')?.invalid && accommodationForm.get('sectionNote')?.touched }">
                  <app-text-formatting-input formControlName="sectionNote"></app-text-formatting-input>
                </div>
              </div>
            </div>
          </div>
        </div>




      </div>
    </form>
  </div>

  <div class="ion-padding-horizontal justify-content-between itinerary-model-footer">
    <div class="d-flex align-items-center">
      <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
        Reset
      </ion-button>
    </div>
    
    <div class="d-flex align-items-center">
      <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
        Save
      </ion-button>
      <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
        Save & Next
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
        <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>